import _styled from "@emotion/styled-base";
export var LightboxModal = _styled("div", {
  target: "e1ine7yt0"
})({
  name: "1o2kpt5",
  styles: "align-items:center;background:rgba(0,0,0,0.9);bottom:0;display:flex;font-size:1em;justify-content:center;left:0;position:fixed;right:0;top:0;"
});
export var LightboxContent = _styled("div", {
  target: "e1ine7yt1"
})({
  name: "1tfxb0b",
  styles: "background:#fff;border-radius:8px;box-sizing:border-box;display:flex;flex-direction:column;height:90%;padding:1em;position:relative;width:90%;"
});
export var ImageWrap = _styled("div", {
  target: "e1ine7yt2"
})({
  name: "wa0xmm",
  styles: "flex:1 1 0;min-height:0;width:100%;"
});
export var Image = _styled("img", {
  target: "e1ine7yt3"
})({
  name: "b1i9gk",
  styles: "height:100%;flex:1 1 0;max-height:100%;max-width:100%;object-fit:scale-down;object-position:center center;width:100%;"
});
export var Description = _styled("div", {
  target: "e1ine7yt4"
})({
  name: "1vkz8rm",
  styles: "font-family:var(--font1);flex:0 0 auto;padding-top:1em;"
});
export var Close = _styled("button", {
  target: "e1ine7yt5"
})({
  name: "v17jn",
  styles: "border:2px solid currentColor;border-radius:50%;background:#333;color:#fafafa;font-size:inherit;height:2em;padding:0;position:absolute;right:-0.5em;text-align:center;top:-0.5em;width:2em;"
});
export var Controls = _styled("div", {
  target: "e1ine7yt6"
})({
  name: "1156rdv",
  styles: "display:flex;justify-content:space-between;position:absolute;top:50%;transform:translateY(-50%);width:calc(100% - 2em);button{border:none;border-radius:50%;box-shadow:0 0 1px 1px rgba(255,255,255,0.5);background:#333;color:#fafafa;font-size:inherit;height:2em;padding:0;text-align:center;width:2em;}"
});